/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Execution on Cloud Functions
/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { httpsCallable } from 'firebase/functions'

// //////////////////////////////////////////////////////////////////
// Main Execution
// //////////////////////////////////////////////////////////////////
export default async function (functionName: string, payload?: any) {
  const { $cloudFunctions } = useNuxtApp()
  try {
    const functionCall = httpsCallable($cloudFunctions, functionName)
    const response = await functionCall(payload || {})

    return response.data
  } catch (error) {
    console.error(`Error Calling App Function ${functionName} | ${error}`)

    return { error }
  }
}
